import ObjectID from "bson-objectid";
import moment from "moment";

export const calculateInvoiceSummary = ({ details, isShiftJob, eventName, jobName, date }) => {
  const currentDetails = details ?? [];

  const invoiceRowsIndexedByPositionAndBillRate = {};
  const invoiceDetailRows = currentDetails;
  currentDetails.forEach((data) => {
    const position = data.positionName ?? "";

    // Use both position and billRate as key, so if there are different billRates, it displays a new line for each
    const key = `${position}-${(data.billRate ?? 0).toString()}`;
    if (!invoiceRowsIndexedByPositionAndBillRate[key]) {
      invoiceRowsIndexedByPositionAndBillRate[key] = {};
    }

    // const foundPosition = data.positionName
    //   ? (event.positions ?? []).find(
    //       (pos) => pos.positionName === data.positionName
    //     )
    //   : null

    const item = invoiceRowsIndexedByPositionAndBillRate[key];

    // if (!foundPosition) {
    //   item.payRate = event.payRate
    //   item.billRate = event.billRate
    // } else {
    //   item.payRate = foundPosition.payRate ?? event.payRate
    //   item.billRate = foundPosition.billRate ?? event.billRate
    // }

    item.payRate = data.payRate;
    item.billRate = data.billRate;

    item.positionName = position;
    item.eventName = isShiftJob ? null : eventName;
    item.jobName = isShiftJob ? jobName : null;
    item.date = date;
    item.totalHours = (item.totalHours || 0) + data.totalHours;
    item.totalPay = (item.totalPay || 0) + data.totalPay;
    item.totalBill = (item.totalBill || 0) + data.totalBill;
    item.totalDeductions = (item.totalDeductions || 0) + (data.totalDeductions || 0);
    item.totalOvertimeHours = (item.totalOvertimeHours || 0) + (data.totalOvertimeHours || 0);
    item.totalOvertimePay = (item.totalOvertimePay || 0) + (data.totalOvertimePay || 0);
    item.totalOvertimeBill = (item.totalOvertimeBill || 0) + (data.totalOvertimeBill || 0);

    item.totalAmount = (item.totalBill ?? 0) + (item.totalOvertimeBill ?? 0);

    item.totalEmployees = (item.totalEmployees ?? 0) + 1;

    // Rounding
    item.totalAmount = Math.round(item.totalAmount * 100) / 100;
    item.totalHours = Math.round(item.totalHours * 100) / 100;
    item.totalPay = Math.round(item.totalPay * 100) / 100;
    item.totalBill = Math.round(item.totalBill * 100) / 100;
    item.payRate = Math.round(item.payRate * 100) / 100;
    item.billRate = Math.round(item.billRate * 100) / 100;
    item.totalDeductions = Math.round(item.totalDeductions * 100) / 100;

    item.itemId = new ObjectID().toString();
  });

  return Object.values(invoiceRowsIndexedByPositionAndBillRate);
};
